"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupStore = exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _rootReducer = _interopRequireDefault(require("./rootReducer")); // import { configureStore, applyMiddleware } from '@reduxjs/toolkit';
// import thunkMiddleware from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension';
// import rootReducer from './rootReducer';
// const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware));
// export function setupStore(preloadedState) {
//   return configureStore({
//     reducer: rootReducer,
//     composedEnhancer,
//     preloadedState,
//   });
// }
// const store = configureStore({
//   reducer: rootReducer,
//   composedEnhancer,
// });
// export default store;


var store = (0, _redux.createStore)(_rootReducer["default"], (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk["default"]), // Development Only, ReduxDevTools Extension
(typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object' && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined' ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
  return f;
}));

var setupStore = exports.setupStore = function setupStore(preloadedState) {
  return (0, _redux.createStore)(_rootReducer["default"], preloadedState, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk["default"]), (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object' && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined' ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) {
    return f;
  }));
};

var _default = exports["default"] = store;